import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { header } from "../globalVariables";
import { api, cleanJSON, isJSON } from "../pureFunctions";
import { FilterGenerator } from "./FilterGenerator";

/* const initKachel = {
   heading: { column: "heading", type: "TEXT", label: "Initialer Name der Kachel" },
   kachelId: { column: "kachel_id", type: "TEXT", label: "Kachel-ID" },
   kuerzel: { column: "kuerzel", type: "TEXT", label: "Kürzel" },
   stufenId: { column: "stufen_id", type: "TEXT" },
   filter: { column: "filter", type: "JSONB" },
   tenant: { column: "tenant", type: "TEXT" },
   hinweis: { column: "hinweis", type: "TEXT" },
   standardEskalationsfrist: { column: "standard_eskalationsfrist", type: "INTEGER" },
   maxEskalationsfrist: { column: "max_eskalationsfrist", type: "INTEGER" },
   pflichtEskalation: { column: "pflicht_eskalation", type: "BOOL" },
   pflichtKachel: { column: "pflicht_kachel", type: "BOOL" },
   adminFreigabe: { column: "admin_freigabe", type: "BOOL" },
   pmFreigabe: { column: "pm_freigabe", type: "BOOL" },
   notRemovable: { column: "not_removable", type: "BOOL" },
   unSkippable: { column: "un_skippable", type: "BOOL" },
   deprecated: { column: "deprecated", type: "BOOL" },
   optional: { column: "optional", type: "BOOL" },
   oneClickFinish: { column: "one_click_finish", type: "JSONB" },
   permittedUsers: { column: "permitted_users", type: "JSONB" },
   groups: { column: "groups", type: "JSONB" },
}; */

const initStufe = {
   heading: "",
   stufenId: "",
   kuerzel: "",
   filter: "",
};

export function AddStufe({ projektstufe, allKacheln, setAllKacheln, fieldconfiguration }) {
   const [settings, setSettings] = useState();
   const [loading, setLoading] = useState("");
   const [show, setShow] = useState(false);
   const [showWarning, setShowWarning] = useState();

   function editSettings(name, value) {
      setSettings((prev) => ({ ...prev, [name]: value }));
   }
   const handleClose = () => {
      setShow(false);
   };

   const handleShow = (type) => {
      if (type === "add") {
         if (!settings) setSettings({ ...initStufe });
      } else if (type === "edit") {
         const { kachel, filter, position, ...rest } = allKacheln[projektstufe];
         console.log(rest);

         const myIndex = Object.keys(allKacheln).findIndex((item) => item===projektstufe);

         console.log(allKacheln[projektstufe]);

         setSettings({
            ...rest,
            position: position ?? myIndex,
            stufenId: rest.id,
            filter: filter ? JSON.stringify(filter, null, 2) : "",
         });
      }
      setShow(true);
   };
   async function updateStufe() {
      console.log(settings);
      let cleanData = structuredClone(settings);

      cleanJSON(cleanData, "filter");
      console.log(cleanData);

      await api
         .post("/api/ip/stufen", { stufenId: projektstufe, ...cleanData }, header)
         .then((data) => {
            console.log("saved Data");
            return data.data;
         })
         .catch((err) => {
            console.log(err);
         });

      let newKacheln = structuredClone({
         ...allKacheln,
         [projektstufe]: { ...allKacheln[projektstufe], ...cleanData },
      });
      setAllKacheln(newKacheln);

      localStorage.setItem("kacheln", JSON.stringify(newKacheln));

      await api.get("/api/updateCache").then((data) => {
         console.log(data);
      });

      setShow(false);
   }

   async function deleteStufe() {
      console.log(settings);
      let cleanData = structuredClone(settings);

      // delete cleanData.fields;

      cleanJSON(cleanData, "filter");
      console.log(cleanData);

      const savedResponse = await api
         .patch("/api/ip/archive-stufe", { stufenId: cleanData.stufenId ?? cleanData.id }, header)
         .then((data) => {
            console.log("saved Data");
            console.log(data);
            return data.data;
         })
         .catch((err) => {
            console.log(err);
         });

      await api.get("/api/updateCache").then((data) => {
         console.log(data);
      });
      setShow(false);
   }

   return (
      <>
         <Button
            className="mx-1"
            onClick={() => {
               handleShow("add");
            }}
            variant="outline-dark"
         >
            Stufe hinzufügen
         </Button>

         <Button
            onClick={() => {
               handleShow("edit");
            }}
            variant="outline-dark"
         >
            Stufe bearbeiten
         </Button>

         <Modal show={show} size="xl" onHide={handleClose} dialogClassName="mt-5">
            <Modal.Header closeButton>{/* <Modal.Title>Frage</Modal.Title> */}</Modal.Header>
            <Modal.Body>
               <div className="kachel-edit-menu">
                  <h2>Projektstufeneinstellungen</h2>
                  {settings && (
                     <Form className="mt-4">
                        <Row>
                           <Form.Group as={Col} className="mb-3">
                              <Form.Label>Initialer Name der Kachel</Form.Label>
                              <Form.Control
                                 placeholder="z.B. Datenblatt"
                                 onChange={(e) => {
                                    editSettings(e.target.name, e.target.value);
                                 }}
                                 value={settings.heading}
                                 name={"heading"}
                              />
                           </Form.Group>

                           <Form.Group as={Col} className="mb-3">
                              <Form.Label>Kürzel (2 Buchstaben)</Form.Label>
                              <Form.Control
                                 placeholder="z.B. EW"
                                 maxLength={2}
                                 onChange={(e) => {
                                    editSettings(e.target.name, e.target.value);
                                 }}
                                 value={settings.kuerzel}
                                 name={"kuerzel"}
                              />
                           </Form.Group>
                        </Row>
                        <Row>
                           <Col>
                              <Form.Group className="mb-3">
                                 <Form.Label>Projektstufen-ID</Form.Label>
                                 <Form.Control
                                    placeholder="z.B. datenblatt"
                                    onChange={(e) => {
                                       editSettings(e.target.name, e.target.value);
                                    }}
                                    value={settings.stufenId}
                                    name={"stufenId"}
                                 />
                              </Form.Group>
                           </Col>
                           <Col>
                              <Form.Group className="mb-3">
                                 <Form.Label>Position</Form.Label>
                                 <Form.Control
                                    // placeholder="z.B. datenblatt"
                                    onChange={(e) => {
                                       editSettings(e.target.name, Math.max(e.target.value, 0));
                                    }}
                                    type="number"
                                    step={1}
                                    value={settings.position}
                                    name={"position"}
                                 />
                              </Form.Group>
                           </Col>
                        </Row>

                        <FilterGenerator editSettings={editSettings} respField={"filter"} allKacheln={allKacheln} />
                        <Row>
                           <Col>
                              <Form.Group className="mb-3" controlId="filter">
                                 <Form.Label>Filter (JSON)</Form.Label>
                                 <Form.Control
                                    autoComplete="off"
                                    placeholder=""
                                    style={{ minHeight: "120px" /* fieldSizing: "content" */ }}
                                    as="textarea"
                                    onChange={(e) => {
                                       editSettings(e.target.name, e.target.value);
                                    }}
                                    name="filter"
                                    value={settings.filter}
                                 />
                                 {!isJSON(settings.filter) && (
                                    <div className="mt-1 p-1" style={{ background: "#d00", color: "#fff" }}>
                                       invalide Syntax
                                    </div>
                                 )}
                              </Form.Group>
                           </Col>
                        </Row>
                     </Form>
                  )}
                  {loading === "success" && <Alert variant="success">Speichern erfolgreich!</Alert>}
                  {loading === "error" && <Alert variant="success">Fehler!</Alert>}
                  <div>
                     {!showWarning ? (
                        <Button variant="warning" onClick={() => setShowWarning(true)}>
                           Stufen entfernen
                        </Button>
                     ) : (
                        <>
                           <Button variant="secondary" onClick={() => setShowWarning(false)}>
                              Abbrechen
                           </Button>{" "}
                           <Button
                              variant="danger"
                              onClick={async () => {
                                 await deleteStufe();
                              }}
                           >
                              Projektstufe endgültig löschen!
                           </Button>
                        </>
                     )}
                  </div>
                  <div className="d-flex justify-content-end mt-2">
                     <Button
                        onClick={async () => {
                           await updateStufe();
                        }}
                        className="ms-1"
                     >
                        Speichern und Hochladen
                     </Button>
                  </div>
               </div>
            </Modal.Body>
         </Modal>
      </>
   );
}

function downloadObjectAsJson(exportObj, exportName) {
   // 1. Objekt in JSON-String umwandeln (mit Einrückung für Lesbarkeit)
   const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj, null, 2));

   // 2. Ein unsichtbares <a> Element erstellen
   const downloadAnchorNode = document.createElement("a");
   downloadAnchorNode.setAttribute("href", dataStr);
   downloadAnchorNode.setAttribute("download", exportName + ".json");

   // 3. In den Body einfügen, klicken und wieder entfernen
   document.body.appendChild(downloadAnchorNode);
   downloadAnchorNode.click();
   downloadAnchorNode.remove();
}
